export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!_#$%&'()*+,\-./:;<=>?@£¬[\]^`{|}~"]).{8,30}$/
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const PASSWORD_REQUIREMENTS = [
  {
    id: 'length',
    label: '8-30 chars',
    test: (password: string) => password.length >= 8 && password.length <= 30,
  },
  {
    id: 'lowercase',
    label: 'lowercase',
    test: (password: string) => /[a-z]/.test(password),
  },
  {
    id: 'uppercase',
    label: 'uppercase',
    test: (password: string) => /[A-Z]/.test(password),
  },
  {
    id: 'number',
    label: 'number',
    test: (password: string) => /\d/.test(password),
  },
  {
    id: 'special',
    label: 'special character',
    test: (password: string) => /[!_#$%&'()*+,\-./:;<=>?@£¬[\]^`{|}~"]/.test(password),
  },
]
